export default {"src":"/_next/static/media/addressVerification.3b50576a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};